import * as React from 'react';
import './index.css';
import { widget } from '../../charting_library';
import datafeed from 'Datafeed';

function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function colorByTheme(theme) {
	let colors = theme === "dark" ? {
		gray50: "#10141A",
		primary: "#F7F7F7",
		grid: "#1E2632"
	} : theme === "terminal" ? {
		gray50: "#000000",
		primary: "#F7F7F7",
		grid: "#15191d"
	} : {
		gray50: "#F7F7F7",
		primary: "#000000",
		grid: "#C3C2D4"
	}
	return colors;
}

export class TVChartContainer extends React.PureComponent {
1
	static defaultProps = {
		symbol: 'So11111111111111111111111111111111111111112',
		interval: '60',
		libraryPath: '/charting_library/',
		chartsStorageUrl: 'https://saveload.tradingview.com',
		chartsStorageApiVersion: '1.1',
		clientId: 'tradingview.com',
		userId: 'public_user_id',
		fullscreen: false,
		autosize: true,
		studiesOverrides: {},
	};

	tvWidget = null;
	marketData = null
	constructor(props) {
		super(props);
		this.marketData = props.marketData;
		this.currentTheme = props.currentTheme;
		this.ref = React.createRef();
	}

	componentDidUpdate(prevProps, prevState) {
		console.log("STATE CHANGE", prevProps, this.props)
		if(prevProps.currentTheme !== this.props.currentTheme) {
				//window.location.reload(false);
			let colors = colorByTheme(this.props.currentTheme);
			
			this.tvWidget.applyOverrides({ 'mainSeriesProperties.minTick': '100000,1,false' });
			this.tvWidget.applyOverrides({ 'paneProperties.backgroundType' : 'solid', 'paneProperties.background': colors.gray50})
			this.tvWidget.applyOverrides({ 'paneProperties.backgroundGradientStartColor': colors.gray50, 'paneProperties.backgroundGradientEndColor' : colors.gray50 })
			this.tvWidget.applyOverrides({ 'paneProperties.vertGridProperties.color': colors.grid, 'paneProperties.horzGridProperties.color': colors.grid })
			this.tvWidget.applyOverrides({ 'scalesProperties.textColor': colors.primary})
			this.tvWidget.applyOverrides({ 'scalesProperties.backgroundColor': colors.gray50});
			this.tvWidget.applyOverrides({'paneProperties.separatorColor': colors.gray50});
			this.tvWidget.applyOverrides({'platformProperties.background': colors.gray50});
		}
		if (prevProps.marketData.pairs.base.address !== this.props.marketData.pairs.base.address) {
			console.log("UPDATING SYMBOL______", this.props.marketData.pairs, this.tvWidget);
			if(this.tvWidget && this.tvWidget._ready) {
				this.tvWidget.setSymbol(this.props.marketData.pairs.base.address,this.props.interval, () => console.log("CHART CHANGED"));
				this.tvWidget.applyOverrides({ 'mainSeriesProperties.minTick': '100000000,1,false' });
			} else {
				this.tvWidget._readyHandlers.push(() => {
					this.tvWidget.setSymbol(this.props.marketData.pairs.base.address,this.props.interval, () => console.log("CHART CHANGED"));
					this.tvWidget.applyOverrides({ 'mainSeriesProperties.minTick': '100000000,1,false' });
				})
				// setTimeout(checkReady, 100);
				// function checkReady() {
				// 	console.log("CHECKKK", this.props)
				// 	if(this.tvWidget && this.tvWidget._ready && this.props.marketData) {
				// 		this.tvWidget.setSymbol(this.props.marketData.pairs.base.address,this.props.interval, () => console.log("CHART CHANGED"));
				// 		this.tvWidget.applyOverrides({ 'mainSeriesProperties.minTick': '100000000,1,false' });
				// 	} else setTimeout(checkReady, 100)
				// }
			}
			// 	this.tvWidget?.setSymbol(this.props.marketData.pairs.base.address,this.props.interval, () => console.log("CHART CHANGED"));
			// }
			
		}
	}
	
	componentDidMount() {
		const theme = window.localStorage.getItem("theme") || "terminal";
		let colors = theme === "dark" ? {
			gray50: "#10141A",
			primary: "#F7F7F7",
			grid: "#1E2632"
		} : theme === "terminal" ? {
			gray50: "#000000",
			primary: "#F7F7F7",
			grid: "#15191d"
		} : {
			gray50: "#F7F7F7",
			primary: "#000000",
			grid: "#C3C2D4"
		}
		console.log("THEME", theme, colors)
		const widgetOptions = {
			symbol: this.marketData.pairs.base.address,
			// BEWARE: no trailing slash is expected in feed URL
			datafeed: datafeed,
			interval: this.props.interval,
			container: this.ref.current,
			library_path: this.props.libraryPath,
			locale: getLanguageFromURL() || 'en',
			disabled_features: ['use_localstorage_for_settings','widget_logo'],
			enabled_features: ['study_templates'],
			charts_storage_url: this.props.chartsStorageUrl,
			charts_storage_api_version: this.props.chartsStorageApiVersion,
			client_id: this.props.clientId,
			user_id: this.props.userId,
			theme:theme,
			fullscreen: this.props.fullscreen,
			autosize: this.props.autosize,
			disabled_features: [
				"header_symbol_search",
				"header_compare"
			],
			studies_overrides: this.props.studiesOverrides,
			custom_css_url: '/tradingView.css',
			custom_formatters: {
				priceFormatterFactory: (symbolInfo, minTick) => {
					if (symbolInfo?.fractional || minTick !== 'default' && minTick.split(',')[2] === 'true') {
							return {
									format: (price, signPositive) => {
											// return the appropriate format
											return price.toFixed(10)
									},
							};
					}
					return null; // this is to use default formatter;
			}
			},
			// disabled_features: ["header_symbol_search"],
			overrides: {
        watermark: {
          visible: false,
        },
				"paneProperties.backgroundType": "solid",
				"paneProperties.background": colors.gray50,
				"paneProperties.backgroundGradientStartColor": colors.gray50,
				"paneProperties.backgroundGradientEndColor": colors.gray50,
				"paneProperties.vertGridProperties.color": colors.grid,
				"paneProperties.horzGridProperties.color": colors.grid,
				"scalesProperties.textColor" : "#AAA",
				"mainSeriesProperties.candleStyle.wickUpColor": '#3FB68B',
				"mainSeriesProperties.candleStyle.wickDownColor": '#F35050'
			 }
		};

		const tvWidget = new widget(widgetOptions);
		this.tvWidget = tvWidget;
		tvWidget.applyOverrides({ 'mainSeriesProperties.minTick': '100000,1,false' });
		tvWidget.applyOverrides({ 'paneProperties.backgroundType' : 'solid', 'paneProperties.background': colors.gray50})
		tvWidget.applyOverrides({ 'paneProperties.backgroundGradientStartColor': colors.gray50, 'paneProperties.backgroundGradientEndColor' : colors.gray50 })
		tvWidget.applyOverrides({ 'paneProperties.vertGridProperties.color': colors.grid, 'paneProperties.horzGridProperties.color': colors.grid })
		tvWidget.applyOverrides({ 'scalesProperties.textColor': colors.primary})
	}

	componentWillUnmount() {
		if (this.tvWidget !== null) {
			this.tvWidget.remove();
			this.tvWidget = null;
		}
	}

	render() {
		return (
			<div
				ref={ this.ref }
				className={ 'TVChartContainer' }
			/>
		);
	}
}
